<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="4">
                    <v-menu
                      offset-y
                      bottom
                      right
                      nudge-bottom="10"
                      transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          class="text-capitalize mb-5"
                          depressed
                          large
                          v-bind="attrs"
                          v-on="on"
                          exact>
                          <v-icon left>mdi-plus</v-icon>
                          Buat
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="reusePost"
                          v-if="false">
                          <v-list-item-title>
                            <v-icon left>mdi-google-classroom</v-icon> Pertemuan
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider v-if="false" class="my-1"></v-divider>
                        <v-list-item
                          @click="addTugas">
                          <v-list-item-title>
                            <v-icon left>mdi-clipboard-text</v-icon> Tugas
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="addMateri">
                          <v-list-item-title>
                            <v-icon left>mdi-book</v-icon> Materi
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="reusePost">
                          <v-list-item-title>
                            <v-icon left>mdi-recycle</v-icon> Gunakan kembali
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider class="my-1"></v-divider>
                        <v-list-item
                          @click="addPertemuan">
                          <v-list-item-title>
                            <v-icon left>mdi-calendar-month</v-icon> Buat Pertemuan
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <h6 class="text-h6">List Pertemuan</h6>
                    <v-divider class="my-1"></v-divider>
                    <v-list class="limit-height-scroll">
                      <v-list-item-group
                        v-model="pertemuanselect"
                        color="primary">
                        <v-list-item
                          @click="reloadPage"
                          class="style-border-btm mb-1">
                          <v-list-item-title class="py-3">
                            <div class="d-flex align-center">
                              <div class="d-inline black--text">
                                <div>
                                  <b>Semua Pertemuan</b>
                                </div>
                                <div class="caption">
                                  Tampilkan semua tugas dan materi
                                </div>
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(pert, i) in listpertemuan"
                          :key="i"
                          @click="selectPertemuan(pert, i)"
                          class="style-border-btm mb-1">
                          <v-list-item-title class="py-3">
                            <div class="d-flex align-center">
                              <div class="d-inline black--text">
                                <div>
                                  <b>{{ pert.name_sess }}</b>
                                </div>
                                <div class="caption text-truncate">
                                  {{ pert.topic_sess }}
                                </div>
                                <div class="caption">
                                  {{ pert.start_sess }}
                                </div>
                                <div class="caption">
                                  <v-chip
                                    x-small
                                    :color="pert.s_sess_type === 'reguler' ? 'primary' : 'warning'">
                                    {{ pert.s_sess_type }}
                                  </v-chip>
                                </div>
                              </div>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-card flat v-if="pertemuandata">
                      <v-app-bar flat color="transparent" dense>
                        <v-toolbar-title class="font-weight-bold primary--text">
                          {{ pertemuandata.name_sess }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-row
                          align="center"
                          justify="end">
                          <span class="text-right ml-2">
                            <v-menu
                              offset-y
                              bottom
                              left
                              nudge-bottom="10"
                              transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  class="text-capitalize"
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  exact>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  @click="editPertemuan(pertemuandata)">
                                  <v-list-item-title>Edit</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  @click="deletePertemuan(pertemuandata)">
                                  <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </span>
                        </v-row>
                      </v-app-bar>
                      <v-card-text class="pt-0">
                        <div class="mb-2">
                          <div class="font-weight-bold black--text">
                            Topic: {{ pertemuandata.topic_sess }}
                          </div>
                          <div class="font-weight-bold black--text" v-if="pertemuandata.s_sess_type === 'reguler'">
                            Jarak Radius: <b :class="jarakradius > radius ? 'red--text' : ''">{{ jarakradius }}</b> meter (Max. 500 meter)
                          </div>
                          <div class="caption">
                            {{ pertemuandata.start_sess }} - {{ pertemuandata.end_sess }}
                            <v-chip
                              x-small
                              :color="pertemuandata.s_sess_type === 'reguler' ? 'primary' : 'warning'">
                              {{ pertemuandata.s_sess_type }}
                            </v-chip>
                          </div>
                        </div>
                        <div class="d-inline">
                          <div v-if="pertemuandata.s_sess_type === 'reguler'">
                            <alertsp :alertdata="alertupdate"></alertsp>
                            <v-btn
                              color="success"
                              class="text-capitalize mr-2 mb-2"
                              depressed
                              small
                              :loading="loading.bukaabsen"
                              :disabled="loading.bukaabsen"
                              @click="bukaAbsenReg()">
                              <v-icon left>mdi-calendar-plus</v-icon>
                              Buka Absensi
                            </v-btn>
                            <v-btn
                              color="primary"
                              class="text-capitalize mr-2 mb-2"
                              depressed
                              small
                              @click="rekapAbsenReguler(pertemuandata)">
                              <v-icon left>mdi-calendar-check</v-icon>
                              Rekap Absensi
                            </v-btn>
                            <v-btn
                              color="warning"
                              class="text-capitalize mr-2 mb-2"
                              depressed
                              small
                              @click="getMyloc(pertemuandata.s_sess_lat, pertemuandata.s_sess_long)">
                              <v-icon left>mdi-map-marker-radius</v-icon>
                              Update Lokasi
                            </v-btn>
                            <v-btn
                              v-if="false"
                              color="warning"
                              class="text-capitalize mb-2"
                              depressed
                              small
                              href="https://sion.pnb.ac.id/index.php?page=724"
                              target="_blank">
                              <v-icon left>mdi-calendar-check</v-icon>
                              Absen Dosen (SION)
                            </v-btn>
                          </div>
                          <div v-if="pertemuandata.s_sess_type === 'tambahan'">
                            <alertsp :alertdata="alertclose" class="my-2"></alertsp>
                            <v-btn
                              color="success"
                              class="text-capitalize mr-2 mb-2"
                              depressed
                              small
                              @click="rekapAbsen(pertemuandata)">
                              <v-icon left>mdi-calendar-check</v-icon>
                              Rekap Absensi
                            </v-btn>
                            <v-btn
                              v-if="pertemuandata.s_sess_isclose === '0'"
                              color="error"
                              class="text-capitalize mb-2"
                              depressed
                              small
                              :loading="loading.close"
                              :disabled="loading.close"
                              @click="tutupAbsen(pertemuandata)">
                              <v-icon left>mdi-stop-circle</v-icon>
                              Tutup Absensi
                            </v-btn>
                            <v-btn
                              v-if="pertemuandata.s_sess_isclose === '1'"
                              class="text-capitalize"
                              depressed
                              small
                              disabled>
                              <v-icon left>mdi-stop-circle</v-icon>
                              Sudah ditutup
                            </v-btn>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <h6 v-if="!pertemuandata" class="text-h6">
                      Semua list tugas dan materi
                    </h6>
                    <v-divider class="my-1"></v-divider>
                    <div v-if="postlist.length > 0">
                      <v-expansion-panels flat focusable>
                        <v-expansion-panel
                          v-for="(post, i) in postlist"
                          :key="i">
                          <v-expansion-panel-header
                            hide-actions
                            :class="new Date() > new Date(post.posted_at_post) ? 'showstyle' : 'hidestyle'">
                            <div class="d-flex align-center">
                              <div class="d-inline">
                                <v-btn
                                  outlined
                                  class="mr-2 d-inline"
                                  fab
                                  small
                                  dark
                                  :color="new Date() > new Date(post.posted_at_post) ? 'primary' : 'grey'">
                                  <v-icon>{{ post.type_post === 'materi' ? 'mdi-book' : 'mdi-clipboard-text' }}</v-icon>
                                </v-btn>
                              </div>
                              <div class="d-inline">
                                <div>{{ post.title_post }}</div>
                                <div class="caption font-weight-bold" v-if="post.type_post === 'tugas'">
                                  Due {{ post.duedate_post }}
                                </div>
                                <div class="caption font-weight-bold" v-if="post.type_post === 'materi'">
                                  Posted {{ post.posted_at_post }}
                                </div>
                                <v-chip
                                  x-small
                                  :color="new Date() > new Date(post.posted_at_post) ? 'primary' : 'grey'">
                                  {{ new Date() > new Date(post.posted_at_post) ? 'Ditampilkan' : 'Belum tampil' }}
                                </v-chip>
                              </div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-row
                              align="center"
                              justify="end">
                              <span class="text-right ml-2">
                                <v-menu
                                  offset-y
                                  bottom
                                  left
                                  nudge-bottom="10"
                                  transition="scale-transition">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      color="primary"
                                      class="text-capitalize"
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      exact>
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item
                                      @click="editPost(post)">
                                      <v-list-item-title>Edit</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                      @click="removePost(post)">
                                      <v-list-item-title>Delete</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </span>
                            </v-row>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="pa-1">
                              <div class="content-editor" v-html="post.desc_post"></div>
                            </div>
                            <v-divider class="py-1"></v-divider>
                            <v-btn
                              v-if="post.type_post === 'materi'"
                              color="primary"
                              depressed
                              tile
                              text
                              small
                              class="px-1 text-capitalize"
                              :to="{ name: 'DetailpostmateriDosen', query: { post: post.id_post, class: check.class } }">
                              Lihat materi
                            </v-btn>
                            <v-btn
                              v-if="post.type_post === 'tugas'"
                              color="primary"
                              depressed
                              tile
                              text
                              small
                              class="px-1 text-capitalize"
                              :to="{ name: 'DetailposttugasDosen', query: { post: post.id_post, class: check.class } }">
                              Lihat tugas
                            </v-btn>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                    <div v-if="postlist.length <= 0" class="grey--text text-center pa-3">
                      Belum ada materi atau tugas yang diunggah!
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'ListclassDosen' }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Daftar kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- dialog pertemuan -->
    <v-dialog
      v-model="dmodal.pertemuan"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Pertemuan
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.pertemuan = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="6">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitPertemuan"
                    ref="formaddpertemuan"
                    v-model="formadd.pertemuan"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addpertemuan.name_sess"
                              :rules="[rules.required]"
                              label="Judul pertemuan*"
                              placeholder="Pertemuan 1"
                              name="name_sess">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addpertemuan.topic_sess"
                              :rules="[rules.required]"
                              label="Topik pertemuan*"
                              placeholder="Pendahuluan"
                              name="topic_sess">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              v-model="addpertemuan.s_sess_type"
                              :rules="[rules.required]"
                              :items="listjenispertemuan"
                              label="Jenis Pertemuan *"
                              name="s_sess_type">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              dense
                              v-model="jdwsion"
                              :items="listjdwsion"
                              label="Jadwal SION *"
                              return-object
                              @change="pilihJadwal()"
                              :rules="[rules.required]">
                              <template v-slot:selection="data">
                                <div class="caption">
                                  <div>
                                    <strong>{{ data.item.mataKuliah }}</strong>
                                    <br/>
                                    Kelas <b>{{ data.item.kelas }}</b> (<b>{{ data.item.jadwal_Selanjutnya + ',' + data.item.jadwal_Start + '-' + data.item.jadwal_Selesai}}</b>)
                                    <br/>
                                    Prodi <b>{{ data.item.prodi }}</b>
                                  </div>
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.mataKuliah + '-' + item.kelas }}</v-list-item-title>
                                  <v-list-item-subtitle><b>{{ item.jadwal_Selanjutnya }}</b>, <b>{{ item.jadwal_Start + '-' + item.jadwal_Selesai }}</b></v-list-item-subtitle>
                                  <v-list-item-subtitle>Prodi <b>{{ item.prodi }}</b></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-icon>mdi-coin</v-icon>
                                </v-list-item-action>
                              </template>
                            </v-autocomplete>
                            <!-- update lokasi -->
                            <div v-if="false">
                              Jarak Radius: <b :class="jarakradius > radius ? 'red--text' : ''">{{ jarakradius }} meter</b> (Max. 500 meter)
                              <v-btn
                                x-small
                                class="text-capitalize"
                                tile
                                color="primary"
                                @click="getMyloc(addpertemuan.s_sess_lat, addpertemuan.s_sess_long)">
                                Update lokasi
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" v-if="false">
                            <div class="mb-1"><label>Waktu mulai</label></div>
                            <date-picker
                              class="width100"
                              v-model="addpertemuan.start_sess"
                              type="datetime"
                              placeholder="waktu mulai"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                          <v-col cols="12" md="6" v-if="false">
                            <div class="mb-1"><label>Waktu selesai</label></div>
                            <date-picker
                              class="width100"
                              v-model="addpertemuan.end_sess"
                              type="datetime"
                              placeholder="waktu selesai"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addpertemuan"
                          :disabled="loading.addpertemuan || !formadd.pertemuan"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                        <div class="my-3">
                          Note: Pastikan Jadwal SION yang di pilih sudah sesuai!
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog tugas -->
    <v-dialog
      v-model="dmodal.tugas"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Tugas
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('tugas')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAddTugas"
                    ref="formaddtugas"
                    v-model="formadd.tugas"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addtugas.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="addtugas.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-file-input
                              v-model="addtugas.file_post"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File"
                              show-size>
                            </v-file-input>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              prepend-icon="mdi-youtube"
                              v-model="addtugas.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="addtugas.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Batas pengumpulan</label></div>
                            <date-picker
                              class="width100"
                              v-model="addtugas.duedate_post"
                              type="datetime"
                              placeholder="waktu pengumpulan"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Tampilkan pada</label></div>
                            <date-picker
                              class="width100"
                              v-model="addtugas.posted_at"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addtugas"
                          :disabled="loading.addtugas || !formadd.tugas"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog materi -->
    <v-dialog
      v-model="dmodal.materi"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Materi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('materi')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAddMateri"
                    ref="formaddmateri"
                    v-model="formadd.materi"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addmateri.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="addmateri.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-file-input
                              v-model="addmateri.file_post"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File"
                              show-size>
                            </v-file-input>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              prepend-icon="mdi-youtube"
                              v-model="addmateri.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="addmateri.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Tampilkan pada</label></div>
                            <date-picker
                              class="width100"
                              v-model="addmateri.posted_at"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addmateri"
                          :disabled="loading.addmateri || !formadd.materi"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog reuse -->
    <v-dialog
      v-model="dmodal.reuse"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Select post
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('reuse')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="py-5">
          <v-row justify="center">
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="reuse.selectclass"
                :items="classlist"
                item-value="id_class"
                item-text="nama_class"
                label="Pilih kelas"
                name="selectclass"
                @change="getListPost">
              </v-autocomplete>
              <v-list v-if="listpost.length">
                <v-list-item-group
                  v-model="listselect"
                  color="primary"
                  class="limit-height500-scroll">
                  <v-list-item
                    v-for="(post, i) in listpost"
                    :key="i"
                    @click="selectPostreuse(post)"
                    class="style-border-btm">
                    <v-list-item-title class="py-3">
                      <div class="d-flex align-center">
                        <div class="d-inline">
                          <v-btn
                            outlined
                            class="mr-2 d-inline"
                            fab
                            small
                            dark
                            color="primary">
                            <v-icon>{{ post.type_post === 'materi' ? 'mdi-book' : 'mdi-clipboard-text' }}</v-icon>
                          </v-btn>
                        </div>
                        <div class="d-inline">
                          <div>{{ post.title_post }}</div>
                          <span class="text-right caption font-weight-bold" v-if="post.type_post === 'tugas'">
                            Due {{ post.duedate_post }}
                          </span>
                          <span class="text-right caption font-weight-bold" v-if="post.type_post === 'materi'">
                            Posted {{ post.posted_at_post }}
                          </span>
                        </div>
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div v-if="!listpost.length">
                <b>Pilih salah satu kelas!</b>
              </div>
            </v-col>
            <v-col cols="12" md="8">
              <div v-if="reuse.selectpost">
                <div v-if="reuse.selectpost.type_post === 'materi'">
                  <v-form
                    @submit.prevent="submitReuseMateri"
                    ref="formreusemateri"
                    v-model="formuse.materi"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="reuse.selectpost.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="reuse.selectpost.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-file-input
                              v-model="reuse.selectpost.file_new"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="New file"
                              show-size>
                            </v-file-input>
                          </v-col>
                          <v-col cols="12" md="6" v-if="reuse.selectpost.file_post">
                            <div class="d-flex align-center mt-2">
                              <v-checkbox
                                class="d-inline mr-1"
                                v-model="reuse.selectpost.copyfile"
                                label="Copy existing">
                              </v-checkbox>
                              <div class="d-inline">
                                <a
                                  :href="reuse.selectpost.urlmateri"
                                  target="_blank">
                                  Attachment file
                                </a>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-icon="mdi-youtube"
                              v-model="reuse.selectpost.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="reuse.selectpost.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div><label class="caption">Tampilkan pada</label></div>
                            <date-picker
                              class="datetime-style width100"
                              v-model="reuse.selectpost.posted_at_post"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.reusemateri"
                          :disabled="loading.reusemateri || !formuse.materi"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <div v-if="reuse.selectpost.type_post === 'tugas'">
                  <v-form
                    @submit.prevent="submitReuseTugas"
                    ref="formreusetugas"
                    v-model="formuse.tugas"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="reuse.selectpost.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="reuse.selectpost.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-file-input
                              v-model="reuse.selectpost.file_new"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="New file"
                              show-size>
                            </v-file-input>
                          </v-col>
                          <v-col cols="12" md="6" v-if="reuse.selectpost.file_post">
                            <div class="d-flex align-center mt-2">
                              <v-checkbox
                                class="d-inline mr-1"
                                v-model="reuse.selectpost.copyfile"
                                label="Copy existing">
                              </v-checkbox>
                              <div class="d-inline">
                                <a
                                  :href="reuse.selectpost.urlmateri"
                                  target="_blank">
                                  Attachment file
                                </a>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="reuse.selectpost.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="reuse.selectpost.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div><label class="caption">Batas pengumpulan</label></div>
                            <date-picker
                              class="datetime-style width100"
                              v-model="reuse.selectpost.duedate_post"
                              type="datetime"
                              placeholder="Batas pengumpulan"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div><label class="caption">Tampilkan pada</label></div>
                            <date-picker
                              class="datetime-style width100"
                              v-model="reuse.selectpost.posted_at_post"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.reusetugas"
                          :disabled="loading.reusetugas || !formuse.tugas"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </div>
              <div v-if="!reuse.selectpost" class="my-8 text-center">
                <b>Pilih salah satu post yang akan digunakan lagi!</b>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- edit materi -->
    <v-dialog
      v-model="dmodal.editmateri"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.editmateri">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Edit Materi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.editmateri = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitEditMateri"
                    ref="formeditmateri"
                    v-model="formedit.materi"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.editmateri.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="dmodaldata.editmateri.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="dmodaldata.editmateri.file_post"
                              v-show="false"
                              name="file_post">
                            </v-text-field>
                            <v-file-input
                              v-model="dmodaldata.editmateri.file_new"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File new"
                              show-size>
                            </v-file-input>
                            <a
                              v-if="dmodaldata.editmateri.file_post !== ''"
                              :href="dmodaldata.editmateri.urlpost"
                              target="_blank">
                              Attachment file
                            </a>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="dmodaldata.editmateri.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="dmodaldata.editmateri.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Tampilkan pada</label></div>
                            <date-picker
                              class="width100"
                              v-model="dmodaldata.editmateri.posted_at_post"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.editmateri"
                          :disabled="loading.editmateri || !formedit.materi"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- edit tugas -->
    <v-dialog
      v-model="dmodal.edittugas"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.edittugas">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Edit Tugas
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.edittugas = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitEditTugas"
                    ref="formedittugas"
                    v-model="formedit.tugas"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.edittugas.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="dmodaldata.edittugas.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              v-model="dmodaldata.edittugas.file_post"
                              v-show="false"
                              name="title_post">
                            </v-text-field>
                            <v-file-input
                              v-model="dmodaldata.edittugas.file_new"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File new"
                              show-size>
                            </v-file-input>
                            <a
                              v-if="dmodaldata.edittugas.file_post !== ''"
                              :href="dmodaldata.edittugas.urlpost"
                              target="_blank">
                              Attachment file
                            </a>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              prepend-icon="mdi-youtube"
                              v-model="dmodaldata.edittugas.url_post"
                              label="URL Video"
                              name="url_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="dmodaldata.edittugas.id_session"
                              :items="listpertemuan"
                              item-value="id_session"
                              item-text="name_sess"
                              label="Pilih pertemuan"
                              name="selectsession">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Batas pengumpulan</label></div>
                            <date-picker
                              class="width100"
                              v-model="dmodaldata.edittugas.duedate_post"
                              type="datetime"
                              placeholder="Batas pengumpulan"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="mb-1"><label>Tampilkan pada</label></div>
                            <date-picker
                              class="width100"
                              v-model="dmodaldata.edittugas.posted_at_post"
                              type="datetime"
                              placeholder="waktu tampil"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.edittugas"
                          :disabled="loading.edittugas || !formedit.tugas"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- remove post -->
    <v-dialog
      v-model="dmodal.rpost"
      max-width="450px">
      <v-card v-if="dmodaldata.rpost">
        <v-card-title>
          <span>Hapus postingan</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.rpost = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah Anda yakin ingin menghapus postingan ini? <br>
            <b>{{ dmodaldata.rpost.type_post }}: {{ dmodaldata.rpost.title_post }}</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2 mb-3"
            small
            color="primary"
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemovePost(dmodaldata.rpost)">
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit pertemuan -->
    <v-dialog
      v-model="dmodal.editpertemuan"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.editpertemuan">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Edit Pertemuan
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.editpertemuan = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="6">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitEditPertemuan"
                    ref="formeditpertemuan"
                    v-model="formedit.pertemuan"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.editpertemuan.name_sess"
                              :rules="[rules.required]"
                              label="Judul pertemuan*"
                              placeholder="Pertemuan 1"
                              name="name_sess">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.editpertemuan.topic_sess"
                              :rules="[rules.required]"
                              label="Topik pertemuan*"
                              placeholder="Pendahuluan"
                              name="topic_sess">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="mb-1"><label>Waktu mulai</label></div>
                            <date-picker
                              class="width100"
                              v-model="dmodaldata.editpertemuan.start_sess"
                              type="datetime"
                              placeholder="waktu mulai"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="mb-1"><label>Waktu selesai</label></div>
                            <date-picker
                              class="width100"
                              v-model="dmodaldata.editpertemuan.end_sess"
                              type="datetime"
                              placeholder="waktu selesai"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format"
                              default-value>
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.editpertemuan"
                          :disabled="loading.editpertemuan || !formedit.pertemuan"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update
                        </v-btn>
                        <div class="my-3">
                          Note: Waktu mulai dan selesai, sesuaikan dengan jadwal asli
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- remove post -->
    <v-dialog
      v-model="dmodal.rpertemuan"
      max-width="450px">
      <v-card v-if="dmodaldata.rpertemuan">
        <v-card-title>
          <span>Hapus pertemuan</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.rpertemuan = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah Anda yakin ingin menghapus pertemuan ini? <br>
            <b>{{ dmodaldata.rpertemuan.name_sess }}</b>
          </div>
        </v-card-text>
        <v-card-text>
          <div>
            <v-btn
              class="mb-3"
              small
              color="primary"
              :loading="loading.removepertemuan"
              :disabled="loading.removepertemuan"
              @click="confDelpertemuan(dmodaldata.rpertemuan)">
              Hapus
            </v-btn>
          </div>
          <div class="caption">
            Note: Materi dan Tugas yang ada di pertemuan tidak akan terhapus.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- rekap absen -->
    <v-dialog
      v-model="dmodal.rekapabsen"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="rekapabsen">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Rekap Absensi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.rekapabsen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card flat>
                <v-card-text>
                  <div v-if="pertemuandata">
                    <div class="mb-2">
                      <div class="font-weight-bold primary--text text-h6">
                        {{ pertemuandata.name_sess }}
                      </div>
                      <div class="font-weight-bold black--text">
                        Topic: {{ pertemuandata.topic_sess }}
                      </div>
                      <div class="caption">
                        {{ pertemuandata.start_sess }} - {{ pertemuandata.end_sess }}
                      </div>
                    </div>
                    <div class="d-inline" v-if="false">
                      <v-btn
                        color="success"
                        class="text-capitalize"
                        depressed
                        small>
                        <v-icon left>mdi-download</v-icon>
                        Download
                      </v-btn>
                    </div>
                    <v-divider class="my-3"></v-divider>
                  </div>
                  <v-progress-circular
                    v-if="loading.getabsen"
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                  <v-simple-table
                    v-if="!loading.getabsen && rekapabsen"
                    class="black--text">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>
                            NIM
                          </th>
                          <th>
                            Nama
                          </th>
                          <th>
                            Absen
                          </th>
                          <th>
                            Waktu
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in rekapabsen"
                          :key="item.id_student">
                          <td class="text-no-wrap">
                            {{ item.user_no }}
                          </td>
                          <td>
                            <span
                              class="d-inline-block text-truncate text-no-wrap"
                              style="max-width: 250px;"
                              :title="item.user_firstname + ' ' + item.user_lastname">
                              {{ item.user_firstname }} {{ item.user_lastname }}
                            </span>
                          </td>
                          <td class="text-no-wrap">
                            <v-btn
                              icon
                              small
                              color="primary"
                              @click="updateAbsen(item)">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            {{ item.status_absen ? item.status_absen : '-' }}
                          </td>
                          <td class="text-no-wrap">
                            {{ item.time_absen ? item.time_absen : '-' }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- update absen -->
    <v-dialog
      v-model="dmodal.editabsen"
      max-width="450px">
      <v-card v-if="dmodaldata.editabsen && pertemuandata">
        <v-card-title>
          <span class="text-truncate col-10 pa-0">
            Absensi "{{ pertemuandata.name_sess }}"
          </span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.editabsen = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-divider class="mb-3"></v-divider>
        <v-card-text>
          <div class="mb-3">
            <div class="font-weight-bold black--text">
              {{ dmodaldata.editabsen.user_firstname }} {{ dmodaldata.editabsen.user_lastname }}
            </div>
            <div class="caption">
              {{ dmodaldata.editabsen.user_no }}
            </div>
          </div>
          <v-form
            @submit.prevent="submitUpdateAbsen"
            ref="formupdateabsen"
            v-model="formadd.editabsen"
            lazy-validation>
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-radio-group
              v-model="dmodaldata.editabsen.status_absen"
              row
              :rules="[rules.required]">
              <v-radio
                label="Hadir"
                value="Hadir">
              </v-radio>
              <v-radio
                label="Ijin"
                value="Ijin">
              </v-radio>
              <v-radio
                label="Sakit"
                value="Sakit">
              </v-radio>
              <v-radio
                label="Alpa"
                value="Alpa">
              </v-radio>
            </v-radio-group>
            <v-btn
              depressed
              class="my-3 text-capitalize"
              :loading="loading.editabsen"
              :disabled="loading.editabsen || !formadd.editabsen"
              color="primary"
              type="submit">
              Simpan
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- rekap absen reguler -->
    <v-dialog
      v-model="dmodal.rekapabsenreg"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="rekapabsenreg">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Rekap Absensi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.rekapabsenreg = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="10">
              <v-card flat>
                <v-card-text>
                  <div v-if="pertemuandata">
                    <div class="mb-2">
                      <div class="font-weight-bold primary--text text-h6">
                        {{ pertemuandata.name_sess }}
                      </div>
                      <div class="font-weight-bold black--text">
                        Topic: {{ pertemuandata.topic_sess }}
                      </div>
                      <div class="font-weight-bold black--text" v-if="pertemuandata.s_sess_type === 'reguler'">
                        Jarak Radius: <b :class="jarakradius > radius ? 'red--text' : ''">{{ jarakradius }} meter</b> (Max. 500 meter)
                      </div>
                      <div class="caption">
                        {{ pertemuandata.start_sess }} - {{ pertemuandata.end_sess }}
                      </div>
                    </div>
                    <div class="d-inline">
                      <v-btn
                        small
                        class="text-capitalize mr-1"
                        depressed
                        color="warning"
                        @click="getMyloc(pertemuandata.s_sess_lat, pertemuandata.s_sess_long)">
                        <v-icon left>mdi-map-marker-radius</v-icon>
                        Update lokasi
                      </v-btn>
                      <v-btn
                        v-if="false"
                        color="success"
                        class="text-capitalize"
                        depressed
                        small>
                        <v-icon left>mdi-download</v-icon>
                        Download
                      </v-btn>
                    </div>
                    <v-divider class="my-3"></v-divider>
                  </div>
                  <div>
                    <v-progress-circular
                      v-if="loading.getabsen"
                      :width="3"
                      color="red"
                      indeterminate>
                    </v-progress-circular>
                  </div>
                  <v-data-table
                    v-if="!loading.getabsen && rekapabsenreg"
                    :headers="headerabsenreg"
                    :items="rekapabsenreg"
                    :search="filter.absenreg"
                    :items-per-page="50">
                    <template v-slot:[`item.no`]="{ item, index }">
                      <span :ref="item.nim">{{ index + 1 }}.</span>
                    </template>
                    <template v-slot:[`item.presensi`]="{ item }">
                      <v-radio-group v-model="item.absensi" row mandatory>
                        <v-radio label="H" value="H"></v-radio>
                        <v-radio label="I" value="I"></v-radio>
                        <v-radio label="S" value="S"></v-radio>
                        <v-radio label="D" value="D"></v-radio>
                        <v-radio label="A" value="A"></v-radio>
                      </v-radio-group>
                    </template>
                  </v-data-table>
                  <alertsp :alertdata="alertupdate"></alertsp>
                  <v-btn
                    color="success"
                    class="text-capitalize mr-2 mb-2"
                    large
                    depressed
                    :loading="loading.bukaabsen"
                    :disabled="loading.bukaabsen"
                    @click="bukaAbsenReg()">
                    <v-icon left>mdi-calendar-plus</v-icon>
                    Buka Absensi
                  </v-btn>
                  <v-btn
                    class="text-capitalize mr-2 mb-2"
                    large
                    depressed
                    color="primary"
                    :loading="loading.editabsen"
                    :disabled="loading.editabsen"
                    @click="simpanAbsen()">
                    <v-icon left>mdi-content-save</v-icon>
                    Simpan
                  </v-btn>
                  <v-btn
                    class="text-capitalize mr-2 mb-2"
                    large
                    depressed
                    color="error"
                    :loading="loading.closeabsen"
                    :disabled="loading.closeabsen"
                    @click="simpanCloseAbsen()">
                    <v-icon left>mdi-stop-circle</v-icon>
                    Tutup Absen
                  </v-btn>
                  <div class="black--text">
                    <b>Note:</b>
                    <ul>
                      <li>Absensi bisa di buka 10 Menit sebelum jadwal pertemuan!</li>
                      <li>Jika 'Data Absen tidak ditemukan !!!...', pastikan Absen sudah dibuka (tekan tombol 'Buka Absensi')!</li>
                      <li>Untuk melakukan absensi, pilih status absensi, kemudian tekan 'Simpan'!</li>
                      <li>Pastikan anda telah melakukan absensi, sebelum menutup absensi (tekan tombol 'Tutup Absen')!</li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { VueEditor } from 'vue2-editor';
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'DetailclassworkDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertclose: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertbukaabsen: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      post: false,
      pertemuan: false,
      listpost: false,
      addtugas: false,
      addmateri: false,
      addpertemuan: false,
      editmateri: false,
      edittugas: false,
      editpertemuan: false,
      removepertemuan: false,
      remove: false,
      reusemateri: false,
      getabsen: false,
      editabsen: false,
      closeabsen: false,
      close: false,
      bukaabsen: false,
    },
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    baseurl: process.env.VUE_APP_BASEURL,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    radius: process.env.VUE_APP_RADIUS,
    publickey: '123',
    detaildata: [],
    postlist: [],
    classlist: [],
    listpost: [],
    listpertemuan: [],
    listjenispertemuan: ['reguler', 'tambahan'],
    pertemuanselect: 0,
    pertemuandata: null,
    rekapabsen: [],
    rekapabsenreg: [],
    dataabsenreg: [],
    panduan: null,
    addtugas: {
      title_post: '',
      desc_post: '',
      url_post: '',
      duedate_post: new Date(Date.now() + (3600 * 1000 * 24)).toISOString().substr(0, 10) + ' 00:00:00',
      posted_at: new Date(Date.now() + (3600 * 1000 * 8)).toISOString().substr(0, 10) + ' 00:00:00',
      file_post: null,
      id_session: 0,
    },
    addmateri: {
      title_post: '',
      desc_post: '',
      url_post: '',
      posted_at: new Date(Date.now() + (3600 * 1000 * 8)).toISOString().substr(0, 10) + ' 00:00:00',
      file_post: null,
      id_session: 0,
    },
    addpertemuan: {
      name_sess: '',
      topic_sess: '',
      s_sess_type: '',
      s_sess_jdwhari: '',
      s_sess_long: '',
      s_sess_lat: '',
      s_kelas_id: '',
      s_sess_kpaid: '',
      start_sess: new Date(Date.now() + (3600 * 1000 * 8)).toISOString().substr(0, 10) + ' 00:00:00',
      end_sess: new Date(Date.now() + (3600 * 1000 * 8)).toISOString().substr(0, 10) + ' 00:00:00',
    },
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    listselect: 0,
    reuse: {
      selectclass: null,
      selectpost: null,
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      tugas: false,
      materi: false,
      pertemuan: false,
      editabsen: false,
    },
    formuse: {
      tugas: false,
      materi: false,
    },
    formedit: {
      materi: false,
      tugas: false,
      pertemuan: false,
    },
    filter: {
      absenreg: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
      ],
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      tugas: false,
      materi: false,
      reuse: false,
      editmateri: false,
      edittugas: false,
      editpertemuan: false,
      rpertemuan: false,
      rpost: false,
      pertemuan: false,
      rekapabsen: false,
      rekapabsenreg: false,
      editabsen: false,
    },
    dmodaldata: {
      editmateri: null,
      edittugas: null,
      editpertemuan: null,
      rpertemuan: null,
      rpost: null,
      editabsen: null,
    },
    headerabsenreg: [
      { text: 'No', value: 'no' },
      { text: 'NIM', value: 'nim' },
      { text: 'Nama', value: 'nama' },
      { text: 'Presensi', value: 'presensi' },
      { text: 'Keterangan', value: 'keterangan' },
    ],
    jdwsion: null,
    listjdwsion: [],
    listrekabsen: [],
    tahunaktif: process.env.VUE_APP_TH,
    myloc: {
      lat: 0,
      long: 0,
    },
    jarakradius: 1000,
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getClass();
    }
  },
  created() {
    this.getMyloc(0, 0);
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userno',
    ]),
  },
  methods: {
    getMyloc(lat, long) {
      if (!('geolocation' in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.myloc.lat = position.coords.latitude;
          this.myloc.long = position.coords.longitude;
          if (lat && long) {
            this.pertemuandata.jarak = this.checkLokasi(lat, long);
            this.jarakradius = this.checkLokasi(lat, long);
          }
        },
        (error) => {
          console.log(error.message);
        },
        {maximumAge: 10000, timeout: 5000, enableHighAccuracy: true},
      );
    },
    checkLokasi(lat, long) {
      const radlat1 = Math.PI * lat / 180;
      const radlat2 = Math.PI * this.myloc.lat / 180;
      const radlon1 = Math.PI * long / 180;
      const radlon2 = Math.PI * this.myloc.long / 180;
      const theta = long - this.myloc.long;
      const radtheta = Math.PI * theta / 180;
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = Math.round(dist * 1609.34);
      // console.log(dist);
      return dist;
    },
    updatePertemuan(item) {
      // console.log(item);
      this.alertclose.show = false;
      if (this.tokenscr) {
        this.loading.close = true;
        this.axios
          .put(
            this.api + '/api/pertemuan/close',
            qs.stringify({
              sesi: item.id_session,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.pertemuandata.s_sess_isclose = '1';
                this.alertclose.show = true;
                this.alertclose.type = 'success';
                this.alertclose.text = 'Pertemuan berhasil ditutup!';
              } else {
                this.alertclose.show = true;
                this.alertclose.type = 'error';
                this.alertclose.text = resdata.message;
              }
            } else {
              this.alertclose.show = true;
              this.alertclose.type = 'error';
              this.alertclose.text = 'Internal services error!';
            }
            this.loading.close = false;
          })
          .catch((error) => {
            this.alertclose.show = true;
            this.alertclose.type = 'error';
            this.alertclose.text = 'Internal services error!';
            this.loading.close = false;
          });
      } else {
        this.alertclose.show = true;
        this.alertclose.type = 'error';
        this.alertclose.text = 'Invalid token!';
      }
    },
    submitTutupAbsen(item) {
      // console.log(item);
      // console.log(this.listrekabsen);
      // console.log(this.detaildata);
      this.alertclose.show = false;
      if (this.tokenscr) {
        // console.log(this.regclass);
        this.loading.close = true;
        const strhex = this.detaildata[0].s_kelas_id +
          '' + item.topic_sess +
          '' + 'Kelas tambahan' +
          '' + this.userno +
          '' + item.s_sess_jdwhari +
          '' + this.hash;
        const hashactv = sha256(strhex);
        // list rekap absen
        const arrrekap = [];
        this.listrekabsen.forEach((element) => {
          arrrekap.push({
            nim: element.user_no,
            absensi: element.status_absen ? element.status_absen.charAt(0) : 'A',
          });
        });
        const senddata = {
          kelas_ID: this.detaildata[0].s_kelas_id,
          pokokBahasan: item.topic_sess,
          catatan: 'Kelas tambahan',
          nip: this.userno,
          jadwalHari: item.s_sess_jdwhari,
          hashCode: hashactv.toUpperCase(),
          absensi: arrrekap,
        };
        // console.log(senddata);
        this.axios
          .post(
            this.apision + '/PostingKelasTambahan',
            senddata,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.responseCode === '00') {
                // update absen
                this.updatePertemuan(item);
              } else {
                this.alertclose.show = true;
                this.alertclose.type = 'error';
                this.alertclose.text = resdata.responseDescription;
              }
            } else {
              this.alertclose.show = true;
              this.alertclose.type = 'error';
              this.alertclose.text = 'Internal services error 1!';
            }
            this.loading.close = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertclose.show = true;
            this.alertclose.type = 'error';
            this.alertclose.text = 'Internal services error 2!';
            this.loading.close = false;
          });
      } else {
        this.alertclose.show = true;
        this.alertclose.type = 'error';
        this.alertclose.text = 'Invalid token!';
      }
    },
    tutupAbsen(item) {
      if (this.tokenscr) {
        this.listrekabsen = [];
        this.axios
          .get(
            this.api + '/api/pertemuan/rekapabsen/' + item.id_session + '/' + item.id_class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listrekabsen = resdata.data;
                this.submitTutupAbsen(item);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    pilihJadwal() {
      const jsion = this.jdwsion;
      // nama kelas
      this.addpertemuan.s_sess_jdwhari = jsion.jadwal_Hari;
      this.addpertemuan.s_sess_long = jsion.lng;
      this.addpertemuan.s_sess_lat = jsion.lat;
      this.addpertemuan.s_kelas_id = jsion.kelas_ID;
      this.addpertemuan.start_sess = jsion.jadwal_Selanjutnya + ' ' + jsion.jadwal_Start;
      this.addpertemuan.end_sess = jsion.jadwal_Selanjutnya + ' ' + jsion.jadwal_Selesai;
      this.jarakradius = this.checkLokasi(jsion.lat, jsion.lng);
      // console.log(this.addpertemuan);
    },
    getJadwalsion() {
      this.listjdwsion = [];
      const strhex = this.tahunaktif +
        '' + this.userno +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.userno,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/jadwalmengajardosenall',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listjdwsion = resdata.jadwal;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reloadPage() {
      this.$router.go();
    },
    submitReuseTugas() {
      // console.log(this.reuse.selectpost);
      this.alertupdate.show = false;
      if (this.$refs.formreusetugas.validate()) {
        if (this.tokenscr) {
          this.loading.reusemateri = true;
          const dataadd = this.reuse.selectpost;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('url_post', dataadd.url_post);
          formData.append('id_session', dataadd.id_session);
          formData.append('posted_at_post', dataadd.posted_at_post);
          formData.append('duedate_post', dataadd.duedate_post);
          formData.append('id_class', this.check.class);
          formData.append('type_post', 'tugas');
          formData.append('copyfile', dataadd.copyfile);
          formData.append('file_new', dataadd.file_new);
          // send data
          this.axios
            .post(
              this.api + '/api/post/reuse',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  // this.$refs.formreusetugas.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Tugas "' + resdata.data + '" berhasil di posting';
                  this.getPost();
                  this.getListPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.reusemateri = false;
            })
            .catch((error) => {
              this.loading.reusemateri = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitReuseMateri() {
      // console.log(this.reuse.selectpost);
      this.alertupdate.show = false;
      if (this.$refs.formreusemateri.validate()) {
        if (this.tokenscr) {
          this.loading.reusemateri = true;
          const dataadd = this.reuse.selectpost;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('url_post', dataadd.url_post);
          formData.append('id_session', dataadd.id_session);
          formData.append('posted_at_post', dataadd.posted_at_post);
          formData.append('id_class', this.check.class);
          formData.append('type_post', 'materi');
          formData.append('copyfile', dataadd.copyfile);
          formData.append('file_new', dataadd.file_new);
          // send data
          this.axios
            .post(
              this.api + '/api/post/reuse',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  // this.$refs.formreusemateri.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Materi "' + resdata.data + '" berhasil di posting';
                  this.getPost();
                  this.getListPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.reusemateri = false;
            })
            .catch((error) => {
              this.loading.reusemateri = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    selectPostreuse(item) {
      this.alertupdate.show = false;
      item.copyfile = false;
      item.file_new = null;
      this.reuse.selectpost = item;
    },
    getListClass() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher',
            {
              params: {
                status: 'all',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              this.classlist = [];
              if (resdata.error === false) {
                this.classlist = resdata.data;
                // if (this.classlist.length > 0) {
                //   this.reuse.selectclass = this.classlist[0];
                //   this.getListPost();
                // }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    submitEditTugas() {
      // console.log(this.dmodaldata.edittugas);
      this.alertupdate.show = false;
      if (this.$refs.formedittugas.validate()) {
        if (this.tokenscr) {
          this.loading.edittugas = true;
          const dataadd = this.dmodaldata.edittugas;
          const formData = new FormData();
          // file image
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('url_post', dataadd.url_post);
          formData.append('id_class', dataadd.id_class);
          formData.append('type_post', dataadd.type_post);
          formData.append('duedate_post', dataadd.duedate_post);
          formData.append('posted_at_post', dataadd.posted_at_post);
          formData.append('id_post', dataadd.id_post);
          formData.append('id_session', dataadd.id_session);
          formData.append('file_post', dataadd.file_post);
          formData.append('file_new', dataadd.file_new);
          this.axios
            .post(
              this.api + '/api/post/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = resdata.data.title_post + ' berhasil diupdate!';
                  this.getPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.edittugas = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.edittugas = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitEditMateri() {
      // console.log(this.dmodaldata.editmateri);
      this.alertupdate.show = false;
      if (this.$refs.formeditmateri.validate()) {
        if (this.tokenscr) {
          this.loading.editmateri = true;
          const dataadd = this.dmodaldata.editmateri;
          const formData = new FormData();
          // file image
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('url_post', dataadd.url_post);
          formData.append('id_class', dataadd.id_class);
          formData.append('type_post', dataadd.type_post);
          formData.append('duedate_post', dataadd.duedate_post);
          formData.append('posted_at_post', dataadd.posted_at_post);
          formData.append('id_post', dataadd.id_post);
          formData.append('id_session', dataadd.id_session);
          formData.append('file_post', dataadd.file_post);
          formData.append('file_new', dataadd.file_new);
          this.axios
            .post(
              this.api + '/api/post/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = resdata.data.title_post + ' berhasil diupdate!';
                  this.getPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editmateri = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editmateri = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    editPost(item) {
      this.alertupdate.show = false;
      item.urlpost = this.api + '/upload/post/' + item.file_post;
      if (item.type_post === 'materi') {
        this.dmodal.editmateri = true;
        this.dmodaldata.editmateri = JSON.parse(JSON.stringify(item));
      } else {
        this.dmodal.edittugas = true;
        this.dmodaldata.edittugas = JSON.parse(JSON.stringify(item));
      }
    },
    submitEditPertemuan() {
      this.alertupdate.show = false;
      if (this.$refs.formeditpertemuan.validate()) {
        if (this.tokenscr) {
          this.loading.editpertemuan = true;
          const dataadd = this.dmodaldata.editpertemuan;
          const formData = new FormData();
          // file image
          formData.append('name_sess', dataadd.name_sess);
          formData.append('topic_sess', dataadd.topic_sess);
          formData.append('start_sess', dataadd.start_sess);
          formData.append('end_sess', dataadd.end_sess);
          formData.append('id_class', dataadd.id_class);
          formData.append('id_session', dataadd.id_session);
          this.axios
            .post(
              this.api + '/api/pertemuan/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Pertemuan berhasil diupdate!';
                  this.getPertemuan();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editpertemuan = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editpertemuan = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    editPertemuan(item) {
      this.alertupdate.show = false;
      this.dmodal.editpertemuan = true;
      this.dmodaldata.editpertemuan = JSON.parse(JSON.stringify(item));
    },
    deletePertemuan(item) {
      this.alertupdate.show = false;
      this.dmodal.rpertemuan = true;
      this.dmodaldata.rpertemuan = JSON.parse(JSON.stringify(item));
    },
    confDelpertemuan(item) {
      this.alertupdate.show = false;
      if (this.tokenscr && item) {
        // console.log(item);
        this.loading.removepertemuan = true;
        this.axios
          .delete(
            this.api + '/api/pertemuan/' + item.id_session,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.rpertemuan = false;
                this.dmodaldata.rpertemuan = null;
                this.getPertemuan();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.removepertemuan = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.removepertemuan = false;
          });
      }
    },
    confirmRemovePost(item) {
      this.alertupdate.show = false;
      if (this.tokenscr) {
        // console.log(item);
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/post/' + item.id_post,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.rpost = false;
                this.dmodaldata.rpost = null;
                this.getPost();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      }
    },
    removePost(item) {
      this.alertupdate.show = false;
      this.dmodal.rpost = true;
      this.dmodaldata.rpost = JSON.parse(JSON.stringify(item));
      // console.log(item);
    },
    submitAddMateri() {
      this.alertupdate.show = false;
      if (this.$refs.formaddmateri.validate()) {
        if (this.tokenscr) {
          this.loading.addmateri = true;
          const dataadd = this.addmateri;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('posted_at', dataadd.posted_at);
          formData.append('url_post', dataadd.url_post);
          formData.append('id_session', dataadd.id_session);
          formData.append('id_class', this.check.class);
          formData.append('type_post', 'materi');
          // send data
          this.axios
            .post(
              this.api + '/api/post/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddmateri.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Materi "' + resdata.data + '" berhasil di posting';
                  this.getPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addmateri = false;
            })
            .catch((error) => {
              this.loading.addmateri = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitAddTugas() {
      this.alertupdate.show = false;
      if (this.$refs.formaddtugas.validate()) {
        if (this.tokenscr) {
          this.loading.addtugas = true;
          const dataadd = this.addtugas;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('url_post', dataadd.url_post);
          formData.append('duedate_post', dataadd.duedate_post);
          formData.append('posted_at', dataadd.posted_at);
          formData.append('id_session', dataadd.id_session);
          formData.append('id_class', this.check.class);
          formData.append('type_post', 'tugas');
          // send data
          this.axios
            .post(
              this.api + '/api/post/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddtugas.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Tugas "' + resdata.data + '" berhasil di posting';
                  this.getPost();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addtugas = false;
            })
            .catch((error) => {
              this.loading.addtugas = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitPertemuan() {
      if (this.$refs.formaddpertemuan.validate()) {
        if (this.tokenscr) {
          // add tambahan
          this.addDataPertemuan();
          // if (this.addpertemuan.s_sess_type === 'reguler') {
          //   // add reguler - belum
          //   this.bukaAbsenReg();
          // } else {
          //   // add tambahan
          //   this.addDataPertemuan();
          // }
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    addDataPertemuan() {
      this.alertupdate.show = false;
      this.loading.addpertemuan = true;
      const dataadd = this.addpertemuan;
      const formData = new FormData();
      // file image
      formData.append('name_sess', dataadd.name_sess);
      formData.append('topic_sess', dataadd.topic_sess);
      formData.append('start_sess', dataadd.start_sess);
      formData.append('end_sess', dataadd.end_sess);
      formData.append('s_sess_type', dataadd.s_sess_type);
      formData.append('s_sess_jdwhari', dataadd.s_sess_jdwhari);
      formData.append('s_sess_long', dataadd.s_sess_long);
      formData.append('s_sess_lat', dataadd.s_sess_lat);
      formData.append('s_sess_kpaid', dataadd.s_sess_kpaid);
      formData.append('id_class', this.check.class);
      // send data
      this.axios
        .post(
          this.api + '/api/pertemuan/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': 'bearer ' + this.tokenscr,
            },
          },
        )
        .then((res) => {
          // console.log(res);
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              this.$refs.formaddpertemuan.reset();
              this.alertupdate.show = true;
              this.alertupdate.type = 'success';
              this.alertupdate.text = 'Pertemuan "' + resdata.data + '" berhasil di posting';
              this.getPertemuan();
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = resdata.message;
            }
          } else {
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
          }
          this.loading.addpertemuan = false;
        })
        .catch((error) => {
          this.loading.addpertemuan = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Internal services error!';
        });
    },
    updateDataPertemuan(kpaId) {
      // console.log('update pertemuan');
      if (this.tokenscr && this.pertemuandata.id_session && kpaId) {
        const dataadd = this.pertemuandata;
        const formData = new FormData();
        // file image
        formData.append('kpa_id', kpaId);
        formData.append('id_session', dataadd.id_session);
        this.axios
          .post(
            this.api + '/api/pertemuan/updatekpaid',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.getPertemuan();
              }
              // get pertemuan
              // this.rekapAbsenReguler(this.pertemuandata);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    bukaAbsenReg() {
      this.alertupdate.show = false;
      if (this.jarakradius <= 1000000) {
        this.loading.bukaabsen = true;
        const strhex = this.pertemuandata.s_kelas_id +
          '' + this.pertemuandata.topic_sess +
          '' + this.pertemuandata.name_sess +
          '' + this.userno +
          '' + this.pertemuandata.s_sess_jdwhari +
          '' + this.hash;
        const hashactv = sha256(strhex);
        const senddata = {
          Kelas_ID: this.pertemuandata.s_kelas_id,
          PokokBahasan: this.pertemuandata.topic_sess,
          Catatan: this.pertemuandata.name_sess,
          NIP: this.userno,
          JadwalHari: this.pertemuandata.s_sess_jdwhari,
          hashCode: hashactv.toUpperCase(),
        };
        // console.log(senddata);
        // console.log(this.pertemuandata);
        this.axios
          .post(
            this.apision + '/BukaAbsensiReguler',
            senddata,
            {
              headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // insert pertemuan
              // this.addpertemuan.s_sess_kpaid = '';
              if (resdata.responseCode === '00') {
                // this.addpertemuan.s_sess_kpaid = resdata.kpa_id;
                // update kpa_id
                // this.updateDataPertemuan(resdata.kpa_id);
                // buka rekap absen
                this.rekapAbsenReguler(this.pertemuandata);
              } else if (resdata.responseCode === '03') {
                // this.rekapAbsenReguler(this.pertemuandata);
                // this.updateDataPertemuan();
                this.alertupdate.show = true;
                this.alertupdate.type = 'warning';
                this.alertupdate.text = 'Absensi telah terbuka, silahkan cek pada Rekap Absensi!';
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.responseDescription;
              }
              this.loading.bukaabsen = false;
              // console.log(resdata);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading.bukaabsen = false;
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Jarak lokasi terlalu jauh!';
      }
    },
    submitAddPertemuan() {
      this.alertupdate.show = false;
      if (this.$refs.formaddpertemuan.validate()) {
        if (this.tokenscr) {
          this.loading.addpertemuan = true;
          const dataadd = this.addpertemuan;
          const formData = new FormData();
          // file image
          formData.append('name_sess', dataadd.name_sess);
          formData.append('topic_sess', dataadd.topic_sess);
          formData.append('start_sess', dataadd.start_sess);
          formData.append('end_sess', dataadd.end_sess);
          formData.append('s_sess_type', dataadd.s_sess_type);
          formData.append('s_sess_jdwhari', dataadd.s_sess_jdwhari);
          formData.append('s_sess_long', dataadd.s_sess_long);
          formData.append('s_sess_lat', dataadd.s_sess_lat);
          formData.append('id_class', this.check.class);
          // send data
          this.axios
            .post(
              this.api + '/api/pertemuan/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddpertemuan.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Pertemuan "' + resdata.data + '" berhasil di posting';
                  this.getPertemuan();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addpertemuan = false;
            })
            .catch((error) => {
              this.loading.addpertemuan = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'tugas') {
        this.dmodal.tugas = false;
      } else if (type === 'materi') {
        this.dmodal.materi = false;
      } else if (type === 'reuse') {
        this.dmodal.reuse = false;
      } else {
        this.dmodal.tugas = false;
      }
    },
    addTugas() {
      this.alertupdate.show = false;
      this.dmodal.tugas = true;
    },
    addMateri() {
      this.alertupdate.show = false;
      this.dmodal.materi = true;
    },
    addPertemuan() {
      this.alertupdate.show = false;
      this.dmodal.pertemuan = true;
    },
    reusePost() {
      this.alertupdate.show = false;
      this.getListClass();
      this.dmodal.reuse = true;
    },
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getPost();
                this.getPertemuan();
                this.getJadwalsion();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getPost() {
      if (this.tokenscr) {
        this.loading.post = true;
        let parampost = {};
        this.postlist = [];
        if (this.pertemuandata) {
          parampost = {
            session: this.pertemuandata.id_session,
          };
        }
        this.axios
          .get(
            this.api + '/api/post/class/' + this.check.class,
            {
              params: parampost,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.postlist = resdata.data;
              }
            }
            this.loading.post = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.post = false;
          });
      }
    },
    getListPost() {
      // console.log(this.reuse.selectclass);
      if (this.tokenscr && this.reuse.selectclass) {
        this.loading.listpost = true;
        this.axios
          .get(
            this.api + '/api/post/class/' + this.reuse.selectclass,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              this.listpost = [];
              if (resdata.error === false) {
                resdata.data.forEach((element) => {
                  element.urlmateri = this.api + '/upload/post/' + element.file_post;
                  this.listpost.push(element);
                });
              }
            }
            this.loading.listpost = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.listpost = false;
          });
      }
    },
    getPertemuan() {
      if (this.tokenscr) {
        this.loading.pertemuan = true;
        this.listpertemuan = [];
        this.axios
          .get(
            this.api + '/api/pertemuan/class/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listpertemuan = resdata.data;
              }
            }
            this.loading.pertemuan = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.pertemuan = false;
          });
      }
    },
    selectPertemuan(item, idx) {
      this.alertclose.show = false;
      this.pertemuandata = item;
      // update jarak
      this.pertemuandata.jarak = this.checkLokasi(item.s_sess_lat, item.s_sess_long);
      this.jarakradius = this.checkLokasi(item.s_sess_lat, item.s_sess_long);
      // console.log(this.pertemuandata);
      // get post
      this.getPost();
      // console.log(item);
      // this.selectidx = idx;
    },
    rekapAbsen(item) {
      if (this.tokenscr) {
        this.dmodal.rekapabsen = true;
        this.loading.getabsen = true;
        this.rekapabsen = [];
        this.axios
          .get(
            this.api + '/api/pertemuan/rekapabsen/' + item.id_session + '/' + item.id_class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.rekapabsen = resdata.data;
                // console.log(this.rekapabsen);
              }
            }
            this.loading.getabsen = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getabsen = false;
          });
      }
    },
    getAbsenRegJalan(item) {
      this.alertupdate.show = false;
      this.dmodal.rekapabsenreg = true;
      this.loading.getabsen = true;
      this.rekapabsenreg = [];
      this.dataabsenreg = [];
      const strhex = item.s_kelas_id +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        Kelas_ID: item.s_kelas_id,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/RekonAbsenBerjalan',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            this.dataabsenreg = resdata;
            if (resdata.responseCode === '00') {
              this.rekapabsenreg = resdata.current_Absensi;
              // update kpa_id
              this.updateDataPertemuan(resdata.kpa_id);
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = resdata.responseDescription;
            }
            this.loading.getabsen = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading.getabsen = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Internal services error!';
        });
    },
    getAbsenReg(item) {
      this.alertupdate.show = false;
      this.dmodal.rekapabsenreg = true;
      this.loading.getabsen = true;
      this.rekapabsenreg = [];
      this.dataabsenreg = [];
      const strhex = item.s_kelas_id +
        '' + item.s_sess_kpaid +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        Kelas_ID: item.s_kelas_id,
        kpa_id: item.s_sess_kpaid,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/RekonAbsensi',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            this.dataabsenreg = resdata;
            if (resdata.responseCode === '00') {
              this.rekapabsenreg = resdata.current_Absensi;
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = resdata.responseDescription;
            }
            this.loading.getabsen = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading.getabsen = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Internal services error!';
        });
    },
    rekapAbsenReguler(item) {
      if (this.tokenscr) {
        if (item.s_sess_kpaid) {
          this.getAbsenReg(item);
        } else {
          this.getAbsenRegJalan(item);
        }
      }
    },
    simpanAbsen() {
      this.alertupdate.show = false;
      if (this.rekapabsenreg && this.dataabsenreg.kelas_ID && this.dataabsenreg.kpa_id) {
        if (this.jarakradius <= this.radius) {
          this.loading.editabsen = true;
          const strhex = this.dataabsenreg.kelas_ID +
            '' + this.dataabsenreg.kpa_id +
            '' + this.pertemuandata.s_sess_jdwhari +
            '' + this.hash;
          const hashactv = sha256(strhex);
          const senddata = {
            Kelas_ID: this.dataabsenreg.kelas_ID,
            kpa_id: this.dataabsenreg.kpa_id,
            JadwalHari: this.pertemuandata.s_sess_jdwhari,
            hashCode: hashactv.toUpperCase(),
            RekonAbsensi: this.rekapabsenreg,
          };
          // console.log(senddata);
          this.axios
            .post(
              this.apision + '/UpdateAbsensiBerjalan',
              senddata,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.responseCode === '00') {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Absensi berhasil di simpan!';
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.responseDescription;
                }
                this.loading.editabsen = false;
              }
            })
            .catch((error) => {
              console.log(error);
              this.loading.editabsen = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Jarak lokasi terlalu jauh!';
        }
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Data absen tidak di temukan atau absen sudah ditutup!';
      }
    },
    simpanCloseAbsen() {
      this.alertupdate.show = false;
      // console.log(this.rekapabsenreg);
      if (this.pertemuandata.s_sess_jdwhari && this.dataabsenreg.kpa_id) {
        if (this.jarakradius <= this.radius) {
          this.loading.closeabsen = true;
          const strhex = this.dataabsenreg.kpa_id +
            '' + this.pertemuandata.s_sess_jdwhari +
            '' + this.hash;
          const hashactv = sha256(strhex);
          const senddata = {
            Kpa_ID: this.dataabsenreg.kpa_id,
            Jadwal_Hari: this.pertemuandata.s_sess_jdwhari,
            hashCode: hashactv.toUpperCase(),
          };
          // console.log(senddata);
          this.axios
            .post(
              this.apision + '/TutupAbsensi',
              senddata,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.responseCode === '00') {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Absensi berhasil di tutup!';
                  // update status pertemuan
                  // this.updatePertemuan(this.pertemuandata);
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.responseDescription;
                }
                this.loading.closeabsen = false;
              }
            })
            .catch((error) => {
              console.log(error);
              this.loading.closeabsen = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Jarak lokasi terlalu jauh!';
        }
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Data absen tidak di temukan atau absen sudah ditutup!';
      }
    },
    updateAbsen(item) {
      this.alertupdate.show = false;
      this.dmodal.editabsen = true;
      this.dmodaldata.editabsen = JSON.parse(JSON.stringify(item));
      // console.log(item);
      // console.log(this.pertemuandata);
    },
    submitUpdateAbsen() {
      // console.log(this.dmodaldata.editabsen);
      this.alertupdate.show = false;
      if (this.$refs.formupdateabsen.validate()) {
        if (this.tokenscr) {
          this.loading.editabsen = true;
          const dataadd = this.dmodaldata.editabsen;
          const formData = new FormData();
          // file image
          formData.append('status_absen', dataadd.status_absen);
          formData.append('id_student', dataadd.id_student);
          formData.append('id_absen', dataadd.id_absen);
          formData.append('id_session', this.pertemuandata.id_session);
          formData.append('id_class', this.check.class);
          // send data
          this.axios
            .post(
              this.api + '/api/pertemuan/updateabsen',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  // this.$refs.formupdateabsen.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Absensi berhasil di simpan!';
                  this.rekapAbsen(this.pertemuandata);
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editabsen = false;
            })
            .catch((error) => {
              this.loading.editabsen = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    DatePicker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
